import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import styles from './LandscapeIndicatorContributionEditTemplate.module.css';
import { Button, Label } from '../../atoms';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { LandscapeIndicatorContributionOrganism } from '../../organisms';
import { VerificationStatusResponseDto } from '../../../store/landscapeAPI/verificationStatus/dto/response/verification-status-response.dto';
import { ValueResponseDto } from '../../../store/landscapeAPI/value/dto/response/value-response.dto';

interface LandscapeIndicatorContributionEditTemplateProps {
  verificationStatuses: VerificationStatusResponseDto[];
  contribution: ValueResponseDto;
  handleOnChange: (contribution: ValueResponseDto) => void;
  callbackFn: (contribution: ValueResponseDto) => void;
}

const LandscapeIndicatorContributionEditTemplate: FC<
  LandscapeIndicatorContributionEditTemplateProps
> = ({ verificationStatuses, contribution, handleOnChange, callbackFn }) => {
  const navigate = useNavigate();
  const { id, landscapeIndicatorId } = useParams();
  return (
    <BaseTemplate>
      <Container>
        <div className={styles.heading}>
          <Label content="Change Landscape Update" size="lg" />
          <Button
            className={styles.buttonLink}
            variant="link"
            onClick={() =>
              navigate(
                `/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/contribution`
              )
            }
          >
            Back to Landscape Indicator detail
          </Button>
        </div>
        <LandscapeIndicatorContributionOrganism
          verificationStatuses={verificationStatuses}
          data={contribution}
          handleOnChange={handleOnChange}
          callbackFn={callbackFn}
        />
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeIndicatorContributionEditTemplate;
